var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.6665,
    y: 32.5,
    width: 86.6667,
    height: 65,
    rx: 10.8333,
    stroke: "url(#paint0_linear_3638_13013)",
    strokeWidth: 10.8333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 48.75L60.155 67.9943C63.2049 69.5192 66.7948 69.5192 69.8446 67.9943L108.333 48.75",
    stroke: "url(#paint1_linear_3638_13013)",
    strokeWidth: 10.8333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3638_13013",
    x1: 108.333,
    y1: 32.5,
    x2: 25.391,
    y2: 101.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3638_13013",
    x1: 108.333,
    y1: 48.75,
    x2: 89.0314,
    y2: 97.2347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.351cd6b2c22726c2411e2ec908abf95e.svg";
export { ForwardRef as ReactComponent };